import React, { useState, useEffect } from "react";
import moment from "moment";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DatePicker from "../../../components/DatePicker";
import ViewHistoryWhItemReturn from "../../../components/Modal/ViewHistoryWhItemReturn";
import FileModal from "../../../components/Modal/FileModal";
import {
  formatCurrency,
  getAlert,
  parseCurrency,
  updateStatusByNo,
} from "../../../../utils/SamuiUtils";
import { formatDate } from "../../../../utils/DateUtils";
import { manageWhItemData } from "../../../../utils/WarehouseUtils";
import { getDataWithComp } from "../../../../utils/SamuiUtils";

const Main = ({
  name,
  dataMasterList,
  dataDetailList,
  dataMasterHistoryList,
  dataDetailHistoryList,
  onPageInsert,
  onPageUpdate,
  callInitialize,
}) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [whCustName, setWhCustName] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [filteredDetailHistoryList, setFilteredDetailHistoryList] = useState(
    []
  );
  const [whHistoryCustName, setWhHistoryCustName] = useState("");
  const [selectedHistoryRow, setSelectedHistoryRow] = useState(null);
  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [returnerName, setReturnerName] = useState("");
  const [returnDate, setReturnDate] = useState(moment());
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileAvailability, setFileAvailability] = useState({}); // State ใหม่สำหรับเก็บสถานะไฟล์แนบ
  const [onRowSelectData, setOnRowSelectData] = useState(null);

  // ดึงข้อมูลไฟล์แนบเมื่อ filteredDetailList เปลี่ยน
  useEffect(() => {
    const fetchFileAvailability = async () => {
      if (filteredDetailList.length === 0) {
        setFileAvailability({});
        return;
      }

      try {
        const docIds = [
          ...new Set(filteredDetailList.map((item) => item.WHDoc_Id)),
        ];
        const filePromises = docIds.map(async (docId) => {
          const files = await getDataWithComp(
            "Upload_File_List",
            `AND DocCode_ID = 6 AND Doc_ID = ${docId} AND File_Status = 'Y'`
          );
          return { docId, hasFiles: files && files.length > 0 };
        });

        const results = await Promise.all(filePromises);
        const availabilityMap = results.reduce((acc, { docId, hasFiles }) => {
          acc[docId] = hasFiles;
          return acc;
        }, {});

        setFileAvailability(availabilityMap);
      } catch (error) {
        console.error("Error fetching file availability:", error);
        setFileAvailability({});
      }
    };

    fetchFileAvailability();
  }, [filteredDetailList]);

  const handleChangeDateMaster = (value, name) => {
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
    setReturnDate(newValue);
  };

  const onRowSelected = async (fromData) => {
    setOnRowSelectData(fromData);
    setSelectedRow(fromData.WHDoc_Cust_Id);
    setFilteredDetailList([]);
    setWhCustName("");
    setSelectedFiles([]);

    setTimeout(() => {
      const filteredDetail = dataDetailList
        .filter(
          (data) =>
            parseCurrency(data.WHDoc_Cust_Id) === fromData.WHDoc_Cust_Id &&
            parseCurrency(data.WHDocStatus_Name) !== "ยกเลิก"
        )
        .sort((a, b) => {
          if (a.WHDoc_No === b.WHDoc_No) {
            return a.Item_Code.localeCompare(b.Item_Code);
          }
          return a.WHDoc_No.localeCompare(b.WHDoc_No);
        });

      if (filteredDetail && filteredDetail.length > 0) {
        setFilteredDetailList(filteredDetail);
      } else {
        setFilteredDetailList([]);
      }

      setWhCustName(fromData.WHDoc_Cust_Name);
    }, 50);
  };

  const onRowSelectHistory = async (fromHistoryData) => {
    setSelectedHistoryRow(fromHistoryData.WHDoc_Cust_Id);
    setFilteredDetailHistoryList([]);
    setWhHistoryCustName("");

    setTimeout(() => {
      const filteredHistoryDetail = dataDetailHistoryList
        .filter(
          (data) =>
            parseCurrency(data.WHDoc_Cust_Id) === fromHistoryData.WHDoc_Cust_Id
        )
        .sort((a, b) => {
          if (a.WHDoc_No === b.WHDoc_No) {
            return a.Item_Code.localeCompare(b.Item_Code);
          }
          return a.WHDoc_No.localeCompare(b.WHDoc_No);
        });

      if (filteredHistoryDetail && filteredHistoryDetail.length > 0) {
        setFilteredDetailHistoryList(filteredHistoryDetail);
      } else {
        setFilteredDetailHistoryList([]);
      }

      setWhHistoryCustName(fromHistoryData.WHDoc_Cust_Name);
    }, 50);
  };

  const [searchItemTerm, setSearchItemTerm] = useState("");
  const filteredItemData = dataMasterList.filter((data) => {
    const matchesItemSearchTerm =
      data.WHDoc_Cust_Code.toLowerCase().includes(
        searchItemTerm.toLowerCase()
      ) ||
      data.WHDoc_Cust_Name.toLowerCase().includes(searchItemTerm.toLowerCase());
    return matchesItemSearchTerm;
  });

  const handleCheckboxChange = (itemSelected) => {
    const updatedSelectedItems = selectedItems.some(
      (item) => item.DT_Id === itemSelected.DT_Id
    )
      ? selectedItems.filter((item) => item.DT_Id !== itemSelected.DT_Id)
      : [...selectedItems, itemSelected];
    setSelectedItems(updatedSelectedItems);
  };

  const handleOpenFileModal = async (item) => {
    try {
      const files = await getDataWithComp(
        "Upload_File_List",
        `AND DocCode_ID = 6 AND Doc_ID = ${item.WHDoc_Id} AND File_Status = 'Y'`
      );
      if (files && files.length > 0) {
        const formattedFiles = files.map((file) => ({
          F_Id: file.File_Id,
          fileName: file.File_Name,
          File_Url: file.File_Url,
          uploadDate: file.Upload_Date,
          uploadBy: file.Upload_By,
        }));
        setSelectedFiles(formattedFiles);
        setShowFileModal(true);
      } else {
        setSelectedFiles([]);
        getAlert("INFO", "ไม่มีไฟล์แนบสำหรับเอกสารนี้");
      }
    } catch (error) {
      console.error("Error fetching files:", error);
      getAlert("FAILED", "ไม่สามารถดึงข้อมูลไฟล์แนบได้: " + error.message);
    }
  };

const handleConfirmReturn = async () => {
    if (selectedItems.length === 0) {
      getAlert("FAILED", "กรุณาเลือกรายการที่ต้องการคืน");
      return;
    }

    for (const selectedItem of selectedItems) {
      await manageWhItemData(
        selectedItem.Item_Id,
        selectedItem.Item_Code,
        selectedItem.Item_Name,
        selectedItem.F_WH_Id,
        "AI",
        parseCurrency(selectedItem.Item_Qty),
        selectedItem.WHDoc_Id,
        selectedItem.WHDoc_No,
        selectedItem.WHDoc_No,
        `คืนสินค้า`
      );

      await updateStatusByNo(
        "WHDoc_D",
        "Item_Is_Return",
        parseCurrency(1),
        `WHERE DT_Id = ${selectedItem.DT_Id}`
      );
      await updateStatusByNo(
        "WHDoc_D",
        "Item_Return_Date",
        formatDate(returnDate),
        `WHERE DT_Id = ${selectedItem.DT_Id}`
      );
      await updateStatusByNo(
        "WHDoc_D",
        "Item_Return_By",
        returnerName,
        `WHERE DT_Id = ${selectedItem.DT_Id}`
      );
    }

    const returnedIds = selectedItems.map(item => item.DT_Id);
    setFilteredDetailList(prevList =>
      prevList.filter(item => !returnedIds.includes(item.DT_Id))
    );

    setSelectedItems([]);
    setIsCheckboxEnabled(false);
    setShowModal(false);
    callInitialize();
    getAlert("OK", "คืนสินค้าเรียบร้อยแล้ว");
  };

  return (
    <>
      <Breadcrumbs
        page={name}
        items={[
          { name: "ใบยืม-ใบเบิก", url: "/borrow-withdrawal" },
          { name: name, url: "/icebox" },
        ]}
      />
      <div className="container-fluid card py-3">
        <div className="row mb-2 align-items-center">
          <div className="col-2">
            <button
              className="btn text-white mx-3"
              onClick={() => onPageInsert()}
              style={{
                backgroundColor: "rgb(239, 108, 0)",
                whiteSpace: "nowrap",
                padding: "10px",
                fontSize: "15px",
              }}
            >
              <i className="fa fa-plus" aria-hidden="true"></i> {name}
            </button>
          </div>
          <div className="col-2">
            <div className="input-group">
              <span className="input-group-text">Search</span>
              <input
                type="text"
                className="form-control"
                value={searchItemTerm}
                onChange={(e) => setSearchItemTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6" />
          <div className="col-2 d-flex justify-content-end">
            <button
              className="btn d-flex align-items-center text-white me-2"
              style={{
                backgroundColor: "rgb(239, 108, 0)",
                fontSize: "16px",
              }}
              onClick={() => setShowHistoryModal(true)}
            >
              <i className="fa fa-search me-2" aria-hidden="true"></i>
              ประวัติการยืม
            </button>
            <ViewHistoryWhItemReturn
              showHistoryModal={showHistoryModal}
              setShowHistoryModal={setShowHistoryModal}
              dataMasterHistoryList={dataMasterHistoryList}
              filteredDetailHistoryList={filteredDetailHistoryList}
              selectedHistoryRow={selectedHistoryRow}
              whHistoryCustName={whHistoryCustName}
              formatCurrency={formatCurrency}
              onRowSelectHistory={onRowSelectHistory}
              onPageUpdate={onPageUpdate}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div
            className="col-4 mb-1"
            style={{ borderRight: "2px solid #c7c8c9" }}
          >
            <div
              className="table-responsive"
              style={{ maxHeight: "650px", overflowY: "auto" }}
            >
              <table
                id="basic-datatables"
                className="table table-striped table-hover"
              >
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "10%" }}>
                      ลำดับ
                    </th>
                    <th className="text-center" style={{ width: "20%" }}>
                      รหัสลูกค้า
                    </th>
                    <th className="text-center" style={{ width: "70%" }}>
                      ชื่อลูกค้า
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItemData.length > 0 ? (
                    filteredItemData.map((data, index) => (
                      <tr
                        key={data.WHDoc_Cust_Id || index + 1}
                        onClick={() => onRowSelected(data)}
                        style={{
                          cursor: "pointer",
                          backgroundColor:
                            selectedRow === data.WHDoc_Cust_Id
                              ? "rgb(105, 188, 216)"
                              : "transparent",
                          transition: "background-color 0.3s ease",
                        }}
                      >
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{data.WHDoc_Cust_Code}</td>
                        <td className="text-left">{data.WHDoc_Cust_Name}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-8 mb-3">
            <div className="justify-content-between align-items-center mb-3">
              <div className="row">
                <div className="col-6">
                  <p className="card-title mb-0">ชื่อลูกค้า: {whCustName}</p>
                </div>
                {!isCheckboxEnabled && filteredDetailList.length > 0 && (
                  <div className="col-6 d-flex justify-content-end">
                    <button
                      className="btn d-flex align-items-center text-white me-2"
                      style={{
                        backgroundColor: "rgb(239, 108, 0)",
                        fontSize: "16px",
                      }}
                      onClick={() => setIsCheckboxEnabled(!isCheckboxEnabled)}
                    >
                      <i className="fa fa-edit me-2" aria-hidden="true"></i>
                      เลือกคืนสินค้า
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div
              className="table-responsive"
              style={{
                maxHeight: "600px",
                overflowY: "auto",
              }}
            >
              <table
                id="basic-datatables"
                className="table table-striped table-hover"
                style={{ minWidth: "100%" }}
              >
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "2%" }}>
                      ลำดับ
                    </th>
                    <th className="text-center" style={{ width: "2%" }}>
                      <input
                        type="checkbox"
                        disabled={!isCheckboxEnabled}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const validItems = filteredDetailList.filter(
                            (item) => item.WHDocStatus_Name !== "ยกเลิก"
                          );
                          setSelectedItems(checked ? validItems : []);
                        }}
                        checked={
                          filteredDetailList.length > 0 &&
                          selectedItems.length ===
                          filteredDetailList.filter(
                            (item) => item.WHDocStatus_Name !== "ยกเลิก"
                          ).length
                        }
                      />
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      วันที่เอกสาร
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      เลขเอกสาร
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      สถานะ
                    </th>
                    <th className="text-center" style={{ width: "15%" }}>
                      รหัสสินค้า
                    </th>
                    <th className="text-center" style={{ width: "49%" }}>
                      ชื่อสินค้า
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      จำนวน
                    </th>
                    <th className="text-center" style={{ width: "2%" }}>
                      ไฟล์
                    </th>
                    <th className="text-center" style={{ width: "2%" }}>
                      <i className="fa fa-edit" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDetailList.length > 0 ? (
                    filteredDetailList
                      .filter((item) => item.Item_Is_Return === 0)
                      .map((item, index) => (
                        <tr
                          key={item.DT_Id || index + 1}
                          style={{
                            cursor: "pointer",
                            backgroundColor: selectedItems.some(
                              (select) => select.DT_Id === item.DT_Id
                            )
                              ? "rgb(105, 188, 216)"
                              : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                        >
                          <td className="text-center">{index + 1}</td>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              disabled={
                                !isCheckboxEnabled ||
                                item.WHDocStatus_Name === "ยกเลิก"
                              }
                              checked={selectedItems.some(
                                (select) => select.DT_Id === item.DT_Id
                              )}
                              onChange={() => handleCheckboxChange(item)}
                              style={{ cursor: "pointer" }}
                            />
                          </td>
                          <td className="text-center">
                            {formatDate(item.WHDoc_Date)}
                          </td>
                          <td className="text-center">{item.WHDoc_No}</td>
                          <td className="text-center">
                            <button
                              className="btn"
                              style={{
                                backgroundColor: item.WHDocStatus_Colour,
                                color: "white",
                                width: "100%",
                              }}
                            >
                              {item.WHDocStatus_Name}
                            </button>
                          </td>
                          <td className="text-center">{item.Item_Code}</td>
                          <td className="text-left">{item.Item_Name}</td>
                          <td className="text-center">
                            {formatCurrency(item.Item_Qty)}
                          </td>
                          <td className="text-center">
                            {fileAvailability[item.WHDoc_Id] ? (
                              <button
                                className="btn btn-sm"
                                onClick={() => handleOpenFileModal(item)}
                              >
                                <i
                                  className="fas fa-paperclip"
                                  style={{
                                    fontSize: "16px",
                                    color: "rgb(239, 108, 0)",
                                  }}
                                ></i>
                              </button>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="text-center">
                            <button
                              hidden={item.WHDocStatus_Name === "ยกเลิก"}
                              className="btn btn-sm"
                              onClick={() => onPageUpdate(item.WHDoc_No)}
                            >
                              <i className="fa fa-edit" />
                            </button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="10">
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>
                <tfoot>
                  {isCheckboxEnabled && (
                    <tr>
                      <td colSpan="10">
                        <div className="d-flex justify-content-left mt-3">
                          <button
                            className="btn btn-lg btn-success me-3"
                            onClick={() => setShowModal(true)}
                            disabled={selectedItems.length === 0}
                          >
                            ยืนยันการคืนสินค้า
                          </button>
                          <button
                            className="btn btn-lg btn-danger"
                            onClick={() => {
                              setIsCheckboxEnabled(false);
                              setSelectedItems([]);
                            }}
                          >
                            ยกเลิกการคืนสินค้า
                          </button>
                        </div>
                      </td>
                    </tr>
                  )}
                  <div
                    className={`modal fade ${showModal ? "show" : ""}`}
                    tabIndex="-1"
                    style={{ display: showModal ? "block" : "none" }}
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title fw-bold">
                            ยืนยันการคืนสินค้า
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowModal(false)}
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <div className="mb-3">
                            <label
                              htmlFor="returnerName"
                              className="form-label"
                            >
                              ชื่อผู้คืนสินค้า
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="returnerName"
                              value={returnerName}
                              onChange={(e) => setReturnerName(e.target.value)}
                              placeholder="กรุณากรอกชื่อ"
                            />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="returnDate" className="form-label">
                              วันที่คืนสินค้า
                            </label>
                            <DatePicker
                              label=""
                              name="returnDate"
                              value={returnDate}
                              onChange={(date) =>
                                handleChangeDateMaster(date, "returnDate")
                              }
                              disabled={false}
                            />
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-lg w-25 shadow text-white"
                            style={{
                              backgroundColor: "#EF6C00",
                              fontSize: "16px",
                            }}
                            onClick={() => handleConfirmReturn()}
                          >
                            ยืนยัน
                          </button>
                          <button
                            type="button"
                            className="btn btn-lg w-25 shadow text-white"
                            style={{ backgroundColor: "red", fontSize: "16px" }}
                            onClick={() => setShowModal(false)}
                          >
                            ยกเลิก
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <FileModal
        mode="S" // โหมดดูอย่างเดียว
        showViewAttachModal={showFileModal}
        setShowViewAttachModal={setShowFileModal}
        selectedFiles={selectedFiles}
        selectedRecFiles={[]} // ไม่มีใบรับสินค้าในหน้าใบยืม
      />
    </>
  );
};

export default Main;
